import { ChartImage } from './ChartImage'
import { WindRoseInteractive } from './WindRoseInteractive'
import { useWindRoseStore } from '../../../store/useWindRoseStore'
import { buildWindRoseChartUrl } from '../../../hooks/useWindRoseData'

// Čistě vykreslovací — podle chartFormat/interactive ze store zobrazí ChartImage
// nebo WindRoseInteractive. Žádné vlastní ovládací prvky, ty jsou ve WindRoseHeader.jsx.
export function WindRoseChart({ station, stype, from, to, vtype, intervals }) {
  const { chartFormat, interactive } = useWindRoseStore()

  const format = interactive ? `json[${chartFormat},meta]` : chartFormat
  const url = buildWindRoseChartUrl({ station: station?.gh_id, stype, from, to, vtype, intervals, format })

  // shrink-0: ve flex-col kontejneru s omezenou výškou by se graf i tabulka jinak
  // smrskly na nulovou výšku a vizuálně se překryly (kontejner scrolluje místo toho)
  return (
    <div className="shrink-0">
      {interactive
        ? <WindRoseInteractive key={url} url={url} />
        : <ChartImage key={url} url={url} />
      }
    </div>
  )
}
